import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../config/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import FeedbackDetailModal from '../components/FeedbackDetailModal';

const MyFeedbackPage = () => {
  const { currentAgent } = useAuth();
  const [feedbacks, setFeedbacks] = useState([]);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeedbacks = async () => {
      if (!currentAgent?.code) {
        setLoading(false);
        return;
      }
      
      const agentCode = currentAgent.code;
      
      try {
        const q = query(
          collection(db, 'feedback'),
          where('agentCode', '==', agentCode),
          orderBy('submittedAt', 'desc'),
          limit(50)
        );
        
        const querySnapshot = await getDocs(q);
        const feedbacksData = [];
        
        querySnapshot.forEach((doc) => {
          feedbacksData.push({
            id: doc.id,
            ...doc.data()
          });
        });
        
        setFeedbacks(feedbacksData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching feedback:', error);
        setLoading(false);
      }
    };

    fetchFeedbacks();
  }, [currentAgent]);

  const handleOpenFeedback = (feedback) => {
    setSelectedFeedback(feedback);
  };

  const handleCloseModal = () => {
    setSelectedFeedback(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">My Feedback</h1>

      {feedbacks.length === 0 ? (
        <div className="bg-white shadow rounded-lg p-6 text-center text-gray-500">
          No feedback has been submitted for your demos yet.
        </div>
      ) : (
        <div className="bg-white shadow rounded-lg divide-y divide-gray-200">
          {feedbacks.map((feedback) => (
            <button
              key={feedback.id}
              onClick={() => handleOpenFeedback(feedback)}
              className="w-full text-left px-4 py-3 hover:bg-gray-50 focus:outline-none"
            >
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-sm font-medium text-gray-900">
                    Demo ID: {feedback.demoId || 'N/A'}
                  </p>
                  <p className="mt-1 text-xs text-gray-500">
                    Submitted:{' '}
                    {feedback.submittedAt
                      ? new Date(feedback.submittedAt).toLocaleString()
                      : 'Unknown'}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
      <FeedbackDetailModal
        open={!!selectedFeedback}
        feedback={selectedFeedback}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export default MyFeedbackPage;
